<template>
    <div class="c-articles" v-if="wordsWithArticles.length">
      <div class="wrap">
        <div class="mb-24" v-html="textArticles ? textArticles.body : '<p>Lees meer over de vragen uit de Woordslang.</p>'"></div>
      </div>
      
      <div class="flex flex-col md:flex-row md:flex-wrap">
        <PuzzleArticleListItem
                v-for="(item, index) in wordsWithArticles"
                :index="index"
                class="md:w-1/2"
                :key="item.id"
                :href="item.href"
                :opengraphData="item.opengraph_data"
        />
      </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { filter, find } from 'lodash'

    import PuzzleArticleListItem from '@/components/puzzle/PuzzleArticleListItem'

    export default {
      name: 'PuzzleArticleList',

      computed: {
        ...mapState({
          puzzle: state => state.currentPuzzle,
          texts: state => state.texts
        }),

        wordsWithArticles () {
          return filter(this.puzzle.words, item => !item.is_bonus && item.href)
        },

        textArticles () {
          return find(this.texts, item => item.realm === 'articles')
        }
      },

      components: {
        PuzzleArticleListItem
      }
    }
</script>